var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-form",
        {
          staticStyle: { background: "white" },
          on: {
            submit: function($event) {
              $event.preventDefault()
            }
          }
        },
        [
          [
            _c("span", { staticClass: "seperator" }),
            _vm._v(" "),
            _c("h4", [
              _vm._v(
                "1. " + _vm._s(_vm.$t("placesAndDirections.citySelection"))
              )
            ]),
            _vm._v(" "),
            _c("city-selector"),
            _vm._v(" "),
            _c("span", { staticClass: "seperator" }),
            _vm._v(" "),
            _c("h4", [
              _vm._v(
                "2. " +
                  _vm._s(_vm.$t("placesAndDirections.timeBasedRouteHeader"))
              )
            ]),
            _vm._v(" "),
            _c("time-based-route", {
              attrs: { places: _vm.places, mapViewData: _vm.mapViewData }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "seperator" }),
            _vm._v(" "),
            _c("h4", [
              _vm._v("3. " + _vm._s(_vm.$t("placesAndDirections.planRoute")))
            ]),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "place-inputs" },
              [
                _c(
                  "draggable",
                  {
                    attrs: { handle: ".reorder-handle" },
                    on: {
                      end: function($event) {
                        return _vm.onReordered()
                      }
                    },
                    model: {
                      value: _vm.places,
                      callback: function($$v) {
                        _vm.places = $$v
                      },
                      expression: "places"
                    }
                  },
                  _vm._l(_vm.getPlaces, function(place, index) {
                    var _obj
                    return _c(
                      "li",
                      { key: index },
                      [
                        _c(
                          "v-layout",
                          { attrs: { row: "" } },
                          [
                            _vm.$store.getters.mode ===
                            _vm.constants.modes.directions
                              ? _c(
                                  "v-flex",
                                  { attrs: { sm2: "", md1: "" } },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "reorder-handle",
                                        attrs: {
                                          small: "",
                                          flat: "",
                                          icon: "",
                                          title: _vm.$t(
                                            "placesAndDirections.reorder"
                                          )
                                        }
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { color: "dark" } },
                                          [_vm._v("reorder")]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              _vm._b(
                                {},
                                "v-flex",
                                ((_obj = {}),
                                (_obj[
                                  _vm.$store.getters.mode ===
                                  _vm.constants.modes.directions
                                    ? "sm10 md11"
                                    : "sm12"
                                ] = true),
                                _obj),
                                false
                              ),
                              [
                                _c("place-input", {
                                  ref: "place" + index,
                                  refInFor: true,
                                  attrs: {
                                    "id-postfix": "places-and-directions",
                                    "support-directions":
                                      _vm.inputSupportsDirections,
                                    "directions-button-tooltip":
                                      _vm.$store.getters.isSidebarVisible &&
                                      _vm.active,
                                    "directions-button-tooltip-position":
                                      "right",
                                    "support-direct-routing": "",
                                    "pick-place-supported":
                                      _vm.places.length > 1,
                                    "support-search": _vm.places.length === 1,
                                    box: _vm.places.length === 1,
                                    index: index,
                                    autofocus: _vm.autofocusEnabled(index),
                                    model: _vm.places[index],
                                    single: _vm.places.length === 1,
                                    "is-last":
                                      _vm.places.length - 1 === index &&
                                      index !== 0
                                  },
                                  on: {
                                    selected: _vm.selectPlace,
                                    changedDirectPlace: _vm.changedDirectPlace,
                                    removeInput: _vm.removePlaceInput,
                                    startDirections: _vm.startDirections,
                                    cleared: _vm.placeCleared
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }),
                  0
                )
              ],
              1
            )
          ],
          _vm._v(" "),
          _c(
            "v-layout",
            { staticClass: "form-actions-btns", attrs: { row: "" } },
            [
              _c("form-actions", {
                attrs: {
                  "place-inputs": _vm.places.length,
                  "disabled-actions": _vm.disabledActions
                },
                on: {
                  addPlaceInput: _vm.addInput,
                  clearPlaces: _vm.clearPlaces,
                  reverseRoute: _vm.reverseRoute,
                  toggleRoundTrip: _vm.toggleRoundTrip,
                  contentUploaded: _vm.contentUploaded
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _vm.showRouteDetails
            ? [
                _c("route-details", {
                  attrs: { "map-view-data": _vm.mapViewData }
                }),
                _vm._v(" "),
                _c("br")
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.$store.getters.mode === _vm.constants.modes.roundTrip
            ? _c("round-trip", { on: { changed: _vm.roundTripFilterChanged } })
            : _vm._e(),
          _vm._v(" "),
          _vm.showAltitudePreview
            ? [
                _c("br"),
                _vm._v(" "),
                _c("altitude-preview", {
                  attrs: { "map-view-data": _vm.mapViewData }
                }),
                _vm._v(" "),
                _c("br")
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.showPlaceDetails
            ? _c("place-details", {
                attrs: { "map-view-data": _vm.mapViewData }
              })
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b208d9f8", { render: render, staticRenderFns: staticRenderFns })
  }
}